import {
  DocumentsDocument,
  DocumentsQuery,
  DocumentsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Document = DocumentsQuery['documents']['documents'][number]

const useGetDocuments = (variables: DocumentsQueryVariables) => {
  const { data, loading, refetch } = useQuery(DocumentsDocument, { variables })

  return {
    documents: data?.documents.documents ?? [],
    policies: data?.documents._policies,
    loading,
    refetch,
  }
}

export default useGetDocuments
